import env from 'src/env';

const supportURL = (lang: string) => {
    switch (lang) {
        case 'fr-FR':
            return `${env.luminaSupportSupportUrl}/fr`;
        case 'da-DK':
            return `${env.luminaSupportSupportUrl}/da`;
        case 'hu-HU':
            return `${env.luminaSupportSupportUrl}/hu`;
        case 'ja-JP':
            return `${env.luminaSupportSupportUrl}/ja`;
        case 'nl-NL':
            return `${env.luminaSupportSupportUrl}/nl`;
        case 'sk-SK':
            return `${env.luminaSupportSupportUrl}/sk`;
        case 'zh-CN':
            return `${env.luminaSupportSupportUrl}/zh-cn`;
        case 'en-GB':
        default:
            return `${env.luminaSupportSupportUrl}`;
    }
};

export default supportURL;